import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export const fetchTipoCoberturaSelect = async () => {
  const query = `
    query {
      allTipocobertura {
        id
        descripcion
      }
    }
  `;

  try {
    const response = await axios.post(rutas.axios + 'api', { query });

    return response.data.data.allTipocobertura
      .map(item => ({
        value: item.id,
        text: item.descripcion,
        codigo: item.descripcion
      }));
  } catch (error) {
    console.error("Error fetching Tipo cobertura:", error);
    return error;
  }
}